import { render, staticRenderFns } from "./ClearCache.vue?vue&type=template&id=3beda834"
import script from "./ClearCache.vue?vue&type=script&lang=js"
export * from "./ClearCache.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports